import { render, staticRenderFns } from "./PhotoDetailsOpener.vue?vue&type=template&id=7bf3518d"
import script from "./PhotoDetailsOpener.vue?vue&type=script&lang=js"
export * from "./PhotoDetailsOpener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports